import {connect} from 'react-redux';

import {InboxesPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {getShouldRecommendDeclutter} from '../../../../store/data/workspace/visualWorkspace/visualWorkspaceSelectors';
import {startedEditingWorkspacesAction} from '../../../../store/panels/inboxes/inboxesPanelActions';
import {WorkspaceHeaderMore} from './workspaceHeaderMore';

interface WorkspaceHeaderMoreContainerProps {
  panelId: InboxesPanelId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  hasRarelyViewedItems: getShouldRecommendDeclutter,
}));

const mapDispatchToProps = makeMapDispatchToProps<WorkspaceHeaderMoreContainerProps>()(({panelId}) => ({
  editWorkspaces: (hasRarelyViewedItems: boolean) =>
    startedEditingWorkspacesAction(panelId, hasRarelyViewedItems),
}));

export const WorkspaceHeaderMoreContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps, ownProps) => {
    const onEditWorkspaces = () => {
      dispatchProps.editWorkspaces(stateProps.hasRarelyViewedItems);
    };
    return {
      ...stateProps,
      ...ownProps,
      onEditWorkspaces,
    };
  },
)(WorkspaceHeaderMore);
